<template>
  <div class="pint7x4positive">
    <div class="label-content">
      <div class="name">商品名：
        <br>
        {{ printData.name }}
      </div>
      <div class="material">
        <div v-html="printData.material"></div>
      </div>
      <canvas id="barcode"></canvas>
      <div class="name" style="margin-top: 50px;">
        <div v-html="printData.company"></div>
      </div>
    </div>
  </div>
</template>

<script>
import JsBarcode from 'jsbarcode'

export default {
  props: {
    printData: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {}
  },
  mounted() {
    this.generateBarcode(this.printData.barcode)
  },
  methods: {
    generateBarcode(barcode) {
      JsBarcode('#barcode', barcode, {
        format: 'EAN13', //选择要使用的条形码类型
        displayValue: true,
        margin: 10,
        width: 5,
        fontSize: 70,//设置文本的大小
        fontWeight: 'bold',//设置文本的大小
        lineColor: "#000000",//设置条和文本的颜色。
        fontOptions: 'bold',
        height: 200,
      })
    },
  }
}
</script>

<style scoped lang="scss">
.pint7x4positive {
  width: 794px;

  margin: 0 auto;
  padding: 30px;
  box-sizing: border-box;
  background-color: #fff;



  .label-content {
    width: 630px;
    padding: 20px;
    box-sizing: border-box;
    background-color: #fff;
    font-size: 40px;

    .name {
      margin-bottom: 30px;
    }

    .material {
      line-height: 80px;
    }


  }
}
</style>